import React, { useState, useEffect, useRef } from "react";
import "../../../../css/CustomComponents/CustomSelect.css";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";

const CustomSelectWithRender = ({
    heading = "Select",
    options = [],
    defaultIndex = 0,
    renderOption,
    renderSelected,
    onChange,
}) => {
    const [isListOpen, setIsListOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(defaultIndex);
    const selectRef = useRef(null);

    const toggleSelect = () => setIsListOpen((prev) => !prev);

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setIsListOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (index) => {
        setSelectedIndex(index);
        onChange(options[index]);
        setIsListOpen(false);
    };

    const selectedOption = options[selectedIndex];

    return (
        <div className="custom-select" ref={selectRef}>
            <p className="select-title">{heading}</p>
            <div className="custom-select-header" onClick={toggleSelect}>
                <span className="custom-select-title">
                    {renderSelected ? renderSelected(selectedOption) : selectedOption}
                </span>
                <span>
                    <img
                        width={20}
                        height={20}
                        src={isListOpen ? ArrowUp : ArrowDown}
                        alt=""
                    />
                </span>
            </div>
            {isListOpen && (
                <div className="custom-select-container">
                    {options.map((option, index) => (
                        <span
                            key={index}
                            className={`custom-select-option ${index === selectedIndex ? "option-selected" : ""
                                }`}
                            onClick={() => handleSelect(index)}
                        >
                            {renderOption ? renderOption(option) : option}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelectWithRender;
